define('lq/licquidRuntimeSentry',[
    'lq/main',
    'lq/runtimeDispatcher',
    'sentry'
], function (lq, RuntimeDispatcher, sentry) {

    var LicquidRuntimeSentry = function (licquidRuntime) {
        this.licquidRuntime = licquidRuntime;
    };

    LicquidRuntimeSentry.prototype.start = function (setup) {
        var self = this;
        var sentryConfig = setup.sentry;
        var licquidRuntime = this.licquidRuntime;

        sentry.onLoad(function () {
            var init = {
                dsn: sentryConfig.dsn,
                tunnel: lq.getTenantUrl('ErrorReporting/Tunnel'),
                release: '-not set-',
                environment: sentryConfig.environment,
                ignoreErrors: lq.sentryIgnoreErrors,
                initialScope: {
                    tags: sentryConfig.tags
                },
                beforeSend(event, hint) {
                    // ----------------------------
                    // 1. Fingerprint
                    // ----------------------------
                    event.fingerprint = sentryConfig.tags.issuesProjectIdentifier
                        ? ['{{ default }}', sentryConfig.tags.issuesProjectIdentifier, sentryConfig.tags.rootMorphId]
                        : ['{{ default }}', sentryConfig.tags.tenant, sentryConfig.tags.application, sentryConfig.tags.rootMorphId];

                    // ----------------------------
                    // 2. Event enrichment at runtime
                    // ----------------------------
                    if (window.licquidRuntime?.action) {

                        event.extra = event.extra || {};

                        event.extra.globalParameters =
                            licquidRuntime.action.piping.parameters.globals.getAll();

                        event.extra.localParameters =
                            licquidRuntime.action.piping.parameters.locals.getAll();

                        event.tags = event.tags || {};
                        event.tags.rootMorphId = licquidRuntime.action.data.id;

                        event.extra.bookmark = {
                            bookmarkType: 'actionBookmarkById',
                            rootMorphId: licquidRuntime.action.data.id
                        };
                    }

                    

                    // ----------------------------
                    // 3. Global runtime metadata
                    // ----------------------------
                    if (licquidRuntime.globalPiping) {
                        const application = licquidRuntime.globalPiping.application;

                        event.release = application.licquidVersion;

                        event.tags.applicationRelease = application.releaseName
                            ? application.releaseName
                            : '-not set-';

                        if (application.userId) {
                            event.user = {
                                id: application.userId
                            };
                        }
                    }

                    // ----------------------------
                    // 4. Last request result
                    // ----------------------------
                    event.extra = event.extra || {};
                    event.extra.lastRequestResult = RuntimeDispatcher.getDescriptionOfLastResponse();

                    return event;
                }
            };

            if (sentryConfig.tracesSampleRate !== undefined) {
                init.integrations = [ Sentry.browserTracingIntegration() ];
                init.tracesSampleRate = sentryConfig.tracesSampleRate;
                init.tracePropagationTargets = sentryConfig.tracePropagationTargets;
            }

            sentry.init(init);

            lq.setSentryLogger(sentry);

            self.startRuntime(setup);
        });
    };

    LicquidRuntimeSentry.prototype.startRuntime = function (setup) {
        this.licquidRuntime.start(setup);
    };

    return LicquidRuntimeSentry;
});
